import { Minus, Plus } from "lucide-react";
import {
	Button,
	Group,
	Input,
	Label,
	NumberField,
} from "react-aria-components";

interface QuantitySelectorProps {
	onQuantityChange: (value: number) => void;
	defaultValue?: number;
	minValue?: number;
	maxValue?: number;
}

export default function QuantitySelector({
	onQuantityChange,
	defaultValue = 1,
	minValue = 1,
	maxValue = 100,
}: QuantitySelectorProps) {
	return (
		<NumberField
			defaultValue={defaultValue}
			minValue={minValue}
			maxValue={maxValue}
			onChange={(newValue) => {
				if (onQuantityChange) onQuantityChange(newValue);
			}}
			className="w-32"
		>
			<Label className="sr-only">Antall</Label>
			<Group className="relative inline-flex h-9 w-full items-center overflow-hidden whitespace-nowrap rounded-lg border border-input text-sm shadow-black/[.04] shadow-xs ring-offset-background transition-shadow data-focus-within:border-ring data-disabled:opacity-50 data-focus-within:outline-hidden data-focus-within:ring-2 data-focus-within:ring-ring/30 data-focus-within:ring-offset-2">
				<Button
					slot="decrement"
					className="-ms-px flex aspect-square h-[inherit] items-center justify-center rounded-s-lg border border-input bg-background text-muted-foreground/80 text-sm ring-offset-background transition-shadow hover:bg-accent hover:text-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
				>
					<Minus size={16} strokeWidth={2} aria-hidden="true" />
				</Button>
				<Input
					min={minValue}
					className="w-full grow bg-background px-3 py-2 text-center text-foreground tabular-nums focus:outline-hidden"
				/>
				<Button
					slot="increment"
					className="-me-px flex aspect-square h-[inherit] items-center justify-center rounded-e-lg border border-input bg-background text-muted-foreground/80 text-sm ring-offset-background transition-shadow hover:bg-accent hover:text-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
				>
					<Plus size={16} strokeWidth={2} aria-hidden="true" />
				</Button>
			</Group>
		</NumberField>
	);
}
